<template>
    <v-container fluid>
        <v-overlay :value="isLoading">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <h2>{{ dbDevice.name }}</h2>
        <v-divider class="mb-3"></v-divider>
        <!-- ============================================= -->
        <v-row>
            <v-col cols="5">
                <v-menu v-model="dispCalender" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field outlined dense v-model="targetDate" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="targetDate" @input="dispCalender = false" locale="ja" :max="maxDate" @change="chartReload()"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="4">
                <v-select outlined dense v-model="daySpanValue" :items="daySpanOptions" @change="chartReload()"></v-select>
            </v-col>
            <v-col cols="3" class="text-right">
                <!--
                <v-btn class="ma-1" :to="{ name: 'DeviceImage', params: { device_id: device_id } }" color="success"><v-icon>mdi-camera-outline</v-icon></v-btn>
                -->
                <v-btn class="ma-1" :to="{ name: 'Playback', params: { device_id: device_id } }" color="success"><v-icon>mdi-video-outline</v-icon></v-btn>
            </v-col>
        </v-row>
        <!-- ################# 水深＆フロート ##################################### -->
        <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
            <v-card-title class="blue darken-2 pa-2">
                <h4 class="white--text">水位(m)</h4>
                <v-spacer></v-spacer>
                <v-btn small color="success" @click="downloadCSV(csvData.xyWaterDepth)">CSV</v-btn>
            </v-card-title>
            <div class="chart-container" style="position: relative; width: 100vw; height: auto; overflow: hidden">
                <comp-chart-depth :chartDataChild="chartDataSetDepth" :yRange="chartRange.depth" style="height: 60vh" />
            </div>
            <v-layout wrap justify-center class="mb-5">
                <div>
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 3px solid green; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">水位</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispDanger">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 2px dashed red; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelDanger }}</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispWarning">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 1px dashed red; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelWarning }}</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispCaution">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 2px dashed orange; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelCaution }}</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispSpillway">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 1px solid grey; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelSpillway }}</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispNormalLow">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 1px dashed blue; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelNormalLow }}</span>
                    </div>
                </div>

                <div v-show="dbDispLines.dispLow">
                    <div class="mx-3 d-flex flex-row align-center">
                        <hr style="border: 2px dashed blue; width: 30px" />
                        <span class="text-caption ml-1" style="white-space: nowrap">{{ dbLabels.labelLow }}</span>
                    </div>
                </div>
            </v-layout>
        </v-card>
        <div class="ma-5"></div>
        <!-- ################# バッテリー ##################################### -->
        <v-card class="overflow-x-auto pa-0 ma-0" elevation="1">
            <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">バッテリー(V)</h4></v-card-title>
            <div class="chart-container" style="position: relative; width: 100vw; height: auto; overflow: hidden">
                <comp-chart-battery :chartDataChild="chartDataSetBattery" :yRange="chartRange.battery" style="height: 60vh" />
            </div>
        </v-card>
        <!-- ################# Finish Time ##################################### -->
        <div class="ma-5">&nbsp;</div>
        <div class="ma-5">&nbsp;</div>
        <div class="text-center"><span class="pa-5" @dblclick="showFinishChart = !showFinishChart">.</span></div>
        <div class="ma-5">&nbsp;</div>
        <div class="ma-5">&nbsp;</div>
        <v-card class="overflow-x-auto pa-0 ma-0" elevation="1" v-show="showFinishChart">
            <v-card-title class="blue darken-2 pa-2"><h4 class="white--text">稼働時間</h4></v-card-title>
            <div class="chart-container" style="position: relative; width: 100vw; height: auto; overflow: hidden">
                <comp-chart-battery :chartDataChild="chartDataSetFinishTime" :yRange="chartRange.finish_time" style="height: 60vh" />
            </div>
        </v-card>
        <div class="ma-5">&nbsp;</div>
        <div class="ma-5">&nbsp;</div>
        <!-- ###################################################### -->
    </v-container>
</template>

<style></style>

<script>
import CompChartDepth from "@/components/CompChartDepth";
import CompChartBattery from "@/components/CompChartBattery";

export default {
    name: "DeviceChart",
    components: {
        CompChartDepth,
        CompChartBattery,
    },
    //========================================================
    data() {
        return {
            jwt: "",
            myInfo: [],
            windowWidth: window.innerWidth, // 画面サイズ
            windowHeight: window.innerHeight, //画面サイズ
            dispCalender: false,
            targetDate: this.$moment().format("YYYY-MM-DD"), //targetDate: "2020-08-21",
            maxDate: this.$moment().format("YYYY-MM-DD"),
            device_id: undefined,
            showFinishChart: false,

            chartColor: {
                depth: "#00640f",
                float: "#FF0000",
                fluct: "#FF0000",
                warning: "#FF0000",
                battery: "#ff2600",
                solar: "#ff9e25",
            },
            chartRange: {
                depth: { min: 0, max: 10 },
                battery: { min: 0, max: 20 },
                solar: { min: 0, max: 30 },
                finish_time: { min: 0, max: 180 },
            },
            daySpanValue: 2,
            daySpanOptions: [
                { text: "1日間", value: 1 },
                { text: "2日間", value: 2 },
                { text: "7日間", value: 7 },
                { text: "14日間", value: 14 },
                { text: "30日間", value: 30 },
            ],
            dbDevice: {},
            dbSensorLogs: undefined,
            dbLabels: {
                labelDanger: "危険水位",
                labelWarning: "危険水位解除",
                labelCaution: "注意",
                labelSpillway: "洪水吐",
                labelNormalLow: "低水位解除",
                labelLow: "低水位",
            },
            dbDispLines: {
                dispDanger: true,
                dispWarning: true,
                dispCaution: true,
                dispSpillway: true,
                dispNormalLow: true,
                dispLow: true,
            },
            dbData: {
                xyLimitDanger: [],
                xyLimitWarning: [],
                xyLimitCaution: [],
                xyLimitSpillway: [],
                xyLimitNormalLow: [],
                xyLimitLow: [],
                xySensorBase: [],

                xyWaterDepth: [],
                xyFloatSw: [],
                xyFluctSw: [],
                xyWarningSw: [],

                xyBattery: [],
                xySolar: [],

                xyFinishTime: [],
                xyLTE: [],
            },
            //---------------------------
            csvData: {
                xyWaterDepth: [],
            },
            //---------------------------
            //---------------------------
            chartDataSetDepth: { datasets: [] },
            chartDataSetBattery: { datasets: [] },
            chartDataSetFinishTime: { datasets: [] },
            //---------------------------
            isLoading: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //---------------------------------------------
        this.device_id = this.$route.params.device_id;
        if (this.$route.query.targetDate) this.targetDate = this.$route.query.targetDate;
        //---------------------------------------------
        //this.modalReset();
        this.isLoading = true;
        //this.localRangeUpdate();
        await this.getDevices();
        await this.getSensorData();
        this.isLoading = false;
        window.scrollTo(0, 0);
    },
    //========================================================
    computed: {},
    //========================================================
    mounted: function () {
        window.addEventListener("resize", this.handleResize);
    },
    //====================================================
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },
    //========================================================
    methods: {
        //====================================================
        handleResize: function () {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        //====================================================
        async chartReload() {
            if (this.myInfo.exp < this.$moment().unix()) this.$router.push({ name: "Login" });
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 500));
            await this.getSensorData();
            this.isLoading = false;
        },
        //====================================================
        async getDevices() {
            const params = {
                id: this.device_id,
                _fields: "id,name,borders,aliases,disp_lines",
            };
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: params,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                if (response.data.json[0]) {
                    this.dbDevice = response.data.json[0];
                    const strBorders = this.dbDevice["borders"];
                    let objBorders = {};
                    if (strBorders) objBorders = JSON.parse(strBorders);
                    this.dbDevice["max"] = objBorders["max"];
                    this.dbDevice["warning_high"] = objBorders["warning_high"];
                    this.dbDevice["normal_high"] = objBorders["normal_high"];
                    this.dbDevice["caution"] = objBorders["caution"];
                    this.dbDevice["spillway"] = objBorders["spillway"];
                    this.dbDevice["normal_low"] = objBorders["normal_low"];
                    this.dbDevice["warning_low"] = objBorders["warning_low"];
                    this.dbDevice["sensor_base"] = objBorders["sensor_base"];
                    this.dbDevice["min"] = objBorders["min"];
                    this.dbDevice["fluctuation"] = objBorders["fluctuation"];
                    //-------------------
                    // ラベル(別名)
                    let strAliases = this.dbDevice["aliases"];
                    let objAliases = null;
                    if (strAliases) {
                        strAliases = strAliases.replace(/\\'/g, "'");
                        strAliases = strAliases.replace(/\\"/g, '"');
                        strAliases = strAliases.replace(/\\\\/g, "\\");
                        objAliases = JSON.parse(strAliases);
                    }
                    if (objAliases) {
                        this.dbLabels.labelDanger = objAliases["warning_high"];
                        this.dbLabels.labelWarning = objAliases["normal_high"];
                        this.dbLabels.labelCaution = objAliases["caution"];
                        this.dbLabels.labelSpillway = objAliases["spillway"];
                        this.dbLabels.labelNormalLow = objAliases["normal_low"];
                        this.dbLabels.labelLow = objAliases["warning_low"];
                    }
                    //-------------------
                    // ライン表示フラグ
                    let objDispLines = null;
                    const strDispLines = this.dbDevice["disp_lines"];
                    if (strDispLines) objDispLines = JSON.parse(strDispLines);
                    if (objDispLines) {
                        this.dbDispLines.dispDanger = objDispLines["warning_high"];
                        this.dbDispLines.dispWarning = objDispLines["normal_high"];
                        this.dbDispLines.dispCaution = objDispLines["caution"];
                        this.dbDispLines.dispSpillway = objDispLines["spillway"];
                        this.dbDispLines.dispNormalLow = objDispLines["normal_low"];
                        this.dbDispLines.dispLow = objDispLines["warning_low"];
                    }
                    //-------------------
                }
            });
        },
        //====================================================
        async localRangeUpdate() {
            if (this.$localStorage.get("chart.range.json") != undefined) {
                let localRange = JSON.parse(this.$localStorage.get("chart.range.json"));
                if (Number(localRange["depth"]["min"])) this.chartRange.depth.min = Number(localRange["depth"]["min"]);
                if (Number(localRange["depth"]["max"])) this.chartRange.depth.max = Number(localRange["depth"]["max"]);
                if (Number(localRange["battery"]["min"])) this.chartRange.battery.min = Number(localRange["battery"]["min"]);
                if (Number(localRange["battery"]["max"])) this.chartRange.battery.max = Number(localRange["battery"]["max"]);
            }
        },
        //====================================================
        async getSensorData() {
            //--------------------------------
            let sdays = (this.daySpanValue - 1) * -1;
            //--------------------------------
            const sdate = this.$moment(this.targetDate).add(sdays, "days").format("YYYY-MM-DD");
            const edate = this.$moment(this.targetDate).add(1, "days").format("YYYY-MM-DD");
            //--------------------------------
            const params = {
                device_id: this.device_id,
                _fields: "sensor_key,sensor_val,arrived_at",
                "arrived_at[EQGREAT]": sdate,
                "arrived_at[SMALL]": edate,
                "_order[arrived_at]": "asc",
            };
            await this.axios({
                method: "GET",
                url: "/web/api/sensor_logs",
                params: params,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbSensorLogs = response.data.json;
                this.registXYLimit(sdate, edate);
                this.registXYdata(sdate, edate);
                this.registSeaChartData();
                //this.localRangeUpdate();
            });
        },
        //====================================================
        registXYLimit(sdate, edate) {
            //----------------------------------------------------------
            const min = this.dbDevice["min"];
            const max = this.dbDevice["max"];
            if (isNaN(Number(min)) == false && isNaN(Number(max)) == false) {
                this.chartRange["depth"] = { min: Number(min), max: Number(max) };
            }
            //----------------------------------------------------------
            const danger = this.dbDevice["warning_high"];
            const warning = this.dbDevice["normal_high"];
            const caution = this.dbDevice["caution"];
            const spillway = this.dbDevice["spillway"];
            const normal_low = this.dbDevice["normal_low"];
            const low = this.dbDevice["warning_low"];
            const sensor_base = this.dbDevice["sensor_base"];
            if (danger && Number(danger) > 0) {
                this.dbData.xyLimitDanger = [
                    { x: sdate, y: Number(danger) },
                    { x: edate, y: Number(danger) },
                ];
            }
            if (warning && Number(warning) > 0) {
                this.dbData.xyLimitWarning = [
                    { x: sdate, y: Number(warning) },
                    { x: edate, y: Number(warning) },
                ];
            }
            if (caution && Number(caution) > 0) {
                this.dbData.xyLimitCaution = [
                    { x: sdate, y: Number(caution) },
                    { x: edate, y: Number(caution) },
                ];
            }
            if (spillway && Number(spillway) > 0) {
                this.dbData.xyLimitSpillway = [
                    { x: sdate, y: Number(spillway) },
                    { x: edate, y: Number(spillway) },
                ];
            }
            if (normal_low && Number(normal_low) > 0) {
                this.dbData.xyLimitNormalLow = [
                    { x: sdate, y: Number(normal_low) },
                    { x: edate, y: Number(normal_low) },
                ];
            }
            if (low && Number(low) > 0) {
                this.dbData.xyLimitLow = [
                    { x: sdate, y: Number(low) },
                    { x: edate, y: Number(low) },
                ];
            }
            if (sensor_base && Number(sensor_base) >= 0) {
                this.dbData.xySensorBase = [
                    { x: sdate, y: Number(sensor_base) },
                    { x: edate, y: Number(sensor_base) },
                ];
            }
        },
        //====================================================
        registXYdata(sdate, edate) {
            //self.console.log(sdate, edate);
            const defaultPoint = [
                { x: sdate, y: null },
                { x: edate, y: null },
            ];
            this.dbData.xyWaterDepth = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyFloatSw = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyFluctSw = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyWarningSw = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyBattery = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xySolar = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyFinishTime = JSON.parse(JSON.stringify(defaultPoint));
            this.dbData.xyLTE = JSON.parse(JSON.stringify(defaultPoint));
            this.csvData.xyWaterDepth = [["日時", "水位(m)"]];
            //--------------------------------
            for (let i in this.dbSensorLogs) {
                let x = this.dbSensorLogs[i].arrived_at;
                x = this.$moment(x).format("YYYY-MM-DD HH:mm");
                let y = this.dbSensorLogs[i].sensor_val;
                let s = this.dbSensorLogs[i].sensor_key;
                if (s == "depth") this.dbData.xyWaterDepth.push({ x: x, y: Number(y) });
                if (s == "battery") this.dbData.xyBattery.push({ x: x, y: Number(y) });
                if (s == "solar") this.dbData.xySolar.push({ x: x, y: Number(y) });
                if (s == "finish_time") this.dbData.xyFinishTime.push({ x: x, y: Number(y) });
                if (s == "connect") this.dbData.xyLTE.push({ x: x, y: Number(y) });
                if (s == "status") {
                    const statusBit = y;
                    const bit_warning = statusBit & 0x01 ? 1 : null; //危険水位
                    // const bit_low = statusBit & 0x02 ? 1 : 0; // 低水位
                    const bit_fluct = statusBit & 0x04 ? 1 : null; //変動水位
                    const bit_float = statusBit & 0x08 ? 1 : null; //フロート水位
                    // y = bit_warning || bit_fluct || bit_float ? 1 : null;
                    this.dbData.xyFloatSw.push({ x: x, y: bit_float });
                    this.dbData.xyFluctSw.push({ x: x, y: bit_fluct });
                    this.dbData.xyWarningSw.push({ x: x, y: bit_warning });
                }
                if (s == "depth") this.csvData.xyWaterDepth.push([x, Number(y)]);
            }
            //--------------------------------
        },
        //====================================================
        registSeaChartData() {
            //----------------------
            // 水位＆フロート
            //----------------------
            this.chartDataSetDepth = { datasets: [] };
            this.chartDataSetDepth.datasets.push({
                label: "水位",
                yAxisID: "axis-depth",
                data: this.dbData.xyWaterDepth,
                borderColor: this.chartColor.depth,
                borderWidth: 3,
                fill: false,
            });
            //----------------------
            this.chartDataSetDepth.datasets.push({
                label: "注意水位超過", // "ステータス(フロート)",
                yAxisID: "axis-float",
                data: this.dbData.xyFloatSw,
                // borderColor: this.chartColor.float,
                borderWidth: 0,
                steppedLine: true, // enable stepped line
                backgroundColor: this.chartColor.float + "4F", //RGBa色で透かす
                fill: true,
                pointRadius: 0, // hide points
            });
            this.chartDataSetDepth.datasets.push({
                label: "変動水位検知", //h"ステータス(変動)",
                yAxisID: "axis-float",
                data: this.dbData.xyFluctSw,
                // borderColor: this.chartColor.fluct,
                borderWidth: 0,
                steppedLine: true, // enable stepped line
                backgroundColor: this.chartColor.fluct + "4F", //RGBa色で透かす
                fill: true,
                pointRadius: 0, // hide points
            });
            this.chartDataSetDepth.datasets.push({
                label: "危険水位超過", //"ステータス(危険)",
                yAxisID: "axis-float",
                data: this.dbData.xyWarningSw,
                //borderColor: this.chartColor.warning,
                borderWidth: 0,
                steppedLine: true, // enable stepped line
                backgroundColor: this.chartColor.warning + "4F", //RGBa色で透かす
                fill: true,
                pointRadius: 0, // hide points
            });
            //----------------------
            if (this.dbDispLines.dispDanger)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelDanger, //"危険水位",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitDanger,
                    borderColor: "red",
                    borderDash: [5, 5],
                    pointRadius: 0, // hide points
                    borderWidth: 2,
                    fill: false,
                });
            if (this.dbDispLines.dispWarning)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelWarning, // "危険水位解除",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitWarning,
                    borderColor: "red",
                    borderDash: [1, 5],
                    pointRadius: 0, // hide points
                    borderWidth: 1,
                    fill: false,
                });
            if (this.dbDispLines.dispCaution)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelCaution, // "注意水位",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitCaution,
                    borderColor: "orange",
                    borderDash: [5, 5],
                    pointRadius: 0, // hide points
                    borderWidth: 2,
                    fill: false,
                });
            if (this.dbDispLines.dispSpillway)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelSpillway, // "洪水吐",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitSpillway,
                    borderColor: "gray",
                    // borderDash: [2, 10],
                    pointRadius: 0, // hide points
                    borderWidth: 2,
                    fill: false,
                });
            if (this.dbDispLines.dispNormalLow)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelNormalLow, // "低水位解除",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitNormalLow,
                    borderColor: "blue",
                    borderDash: [1, 5],
                    pointRadius: 0, // hide points
                    borderWidth: 1,
                    fill: false,
                });
            if (this.dbDispLines.dispLow)
                this.chartDataSetDepth.datasets.push({
                    label: this.dbLabels.labelLow, // "低水位",
                    yAxisID: "axis-depth",
                    data: this.dbData.xyLimitLow,
                    borderColor: "blue",
                    borderDash: [5, 5],
                    pointRadius: 0, // hide points
                    borderWidth: 2,
                    fill: false,
                });
            this.chartDataSetDepth.datasets.push({
                label: "基準高",
                yAxisID: "axis-depth",
                data: this.dbData.xySensorBase,
                borderColor: "grey",
                borderDash: [2, 10],
                pointRadius: 0, // hide points
                borderWidth: 1,
                fill: false,
            });
            //----------------------
            // バッテリー
            //----------------------
            this.chartDataSetBattery = { datasets: [] };
            this.chartDataSetBattery.datasets.push({
                label: "バッテリー",
                yAxisID: "axis-battery",
                data: this.dbData.xyBattery,
                borderColor: this.chartColor.battery,
                borderWidth: 2,
                fill: false,
            });
            this.chartDataSetBattery.datasets.push({
                label: "ソーラー",
                yAxisID: "axis-battery",
                data: this.dbData.xySolar,
                borderColor: this.chartColor.solar,
                borderWidth: 2,
                fill: false,
            });
            //----------------------
            // 稼働時間
            this.chartDataSetFinishTime = { datasets: [] };
            this.chartDataSetFinishTime.datasets.push({
                label: "稼働時間",
                yAxisID: "axis-battery",
                data: this.dbData.xyFinishTime,
                borderColor: "orange",
                borderWidth: 2,
                lineTension: 0,
                fill: false,
            });
            this.chartDataSetFinishTime.datasets.push({
                label: "LTE接続",
                yAxisID: "axis-battery",
                data: this.dbData.xyLTE,
                borderColor: "green",
                borderWidth: 2,
                lineTension: 0,
                fill: false,
            });
            let rangeMax = 30;
            for (let obj of this.dbData.xyFinishTime) if (rangeMax < obj.y) rangeMax = obj.y;
            for (let obj of this.dbData.xyLTE) if (rangeMax < obj.y) rangeMax = obj.y;
            rangeMax = Math.floor(rangeMax / 60) * 60 + 60;
            this.chartRange.finish_time.max = rangeMax;
            //----------------------
        },
        //====================================================
        downloadCSV(data) {
            let deviceName = this.dbDevice.name;
            let mergeAry = data;
            self.console.log(data);
            //----------------------------------------------------------------
            //  配列をCSV化
            //----------------------------------------------------------------
            let csv = "\ufeff" + deviceName + "\n";
            for (let i in mergeAry) {
                csv += mergeAry[i].join(",") + "\n";
            }
            let blob = new Blob([csv], { type: "text/csv" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "ikelog.csv";
            document.body.appendChild(link);
            link.click();
        },
        //====================================================
    },
};
</script>
